import React from 'react';
import styled from 'styled-components';

import type Bundle from 'stores/Bundle';

import BundleLoadingSpinner from './BundleLoadingSpinner';
import BundleOptionsMenu from './BundleOptionsMenu';
import BundleReportButton from './BundleReportButton';
import BundleWarningIcon from './BundleWarningIcon';
import DownloadBundleButton from './DownloadBundleButton';
import GetBundleDownloadLinkButton from './GetBundleDownloadLinkButton';

const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 9px 16px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 7px;
`;

const DateLabel = styled.div`
  font-size: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  color: #333;
`;

const MainLabel = styled.div`
  font-weight: bold;
`;

export interface BundleSummaryRowProps {
  bundle: Bundle;
}

function BundleSummaryRow({ bundle }: BundleSummaryRowProps) {
  return (
    <Container>
      <MainLabel>{bundle.data.name}</MainLabel>

      <ButtonsContainer>
        <DateLabel>{bundle.formattedDateModified}</DateLabel>
        <BundleLoadingSpinner bundle={bundle} />
        <BundleWarningIcon bundle={bundle} />
        <BundleReportButton bundle={bundle} />
        <GetBundleDownloadLinkButton bundle={bundle} />
        <DownloadBundleButton bundle={bundle} />
        <BundleOptionsMenu bundle={bundle} />
      </ButtonsContainer>
    </Container>
  );
}

export default BundleSummaryRow;
